export default __webpack_public_path__ + "static/media/bookbasketimg.b7ed166a.png";